module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBoldItalic.4302020b.ttf";